import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import PageContainer from '../../components/layout/PageContainer';
import PageField from '../../components/layout/PageField';

const NoPage404 = () => {
  return (
    <PageField>
    <PageContainer>
      <Typography variant="h1" sx={{ fontSize: { xs: '2.25rem', md: '3rem' }, mb: 2 }}>
        This page is not on the site.
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3, maxWidth: 520 }}>
        The address may be out of date. The work we do is on the home page.
      </Typography>
      <Button component={Link} to="/" variant="contained">
        Back to home
      </Button>
    </PageContainer>
    </PageField>
  );
};

export default NoPage404;
